import * as React from 'react';
import * as ChartJS from 'chart.js';
import { ProviderConsumer as FluentUIThemeConsumer, Loader } from '@fluentui/react-northstar';
import { ChartTheme } from "./chart-theme";
import { IChartData, EChartTypes } from "./chart-types";
import { BarStackedChart, BarHorizontalStackedChart, LineAreaChart, ChartEmptyState, ChartErrorState } from "../chart/charts";
import BarChart from "../chart/charts/bar";
import BarHorizontalChart from "../chart/charts/bar-horizontal";
import LineChart from "../chart/charts/line";
import LineNoAxesChart from "../chart/charts/line-no-axes";
import DoughnutChart from "../chart/charts/doughnut";
import PieChart from "../chart/charts/pie";
import { getText, TTextObject } from "../../translations";

(ChartJS as any).defaults.global.legend.display = false;
(ChartJS as any).defaults.global.defaultFontFamily = `Segoe UI, system-ui, sans-serif`;

const CHARTS = {
    [EChartTypes.Bar]: BarChart,
    [EChartTypes.BarStacked]: BarStackedChart,
    [EChartTypes.BarHorizontal]: BarHorizontalChart,
    [EChartTypes.BarHorizontalStacked]: BarHorizontalStackedChart,
    [EChartTypes.Line]: LineChart,
    [EChartTypes.LineArea]: LineAreaChart,
    [EChartTypes.LineNoAxes]: LineNoAxesChart,
    [EChartTypes.Pie]: PieChart,
    [EChartTypes.Doughnut]: DoughnutChart,
};

export interface IChartProps {
    title: TTextObject;
    type: EChartTypes;
    data?: IChartData;
    theme?: string;
}

export function Chart({ title, type, data, theme }: IChartProps) {
    if (data && data.datasets && data.datasets.length > 6) {
        data.datasets = data.datasets.slice(0, 6);
        console.warn(
            "Please follow design guidance and apply 6 or fewer data points per one chart."
        );
    }

    const ChartContainer = CHARTS[type];
    return (
        <FluentUIThemeConsumer
            render={(globalTheme) => {
                const { t } = globalTheme.siteVariables;
                return (
                    <ChartTheme globalTheme={globalTheme}>
                        <React.Suspense fallback={<Loader />}>
                            {data ? (
                                data?.datasets.length || data?.labels?.length ? (
                                    <ChartContainer
                                        title={getText(t?.locale, title)}
                                        data={data}
                                        siteVariables={globalTheme.siteVariables}
                                        theme={theme}
                                    />
                                ) : (
                                    <ChartEmptyState siteVariables={globalTheme.siteVariables} />
                                )
                            ) : (
                                <ChartErrorState siteVariables={globalTheme.siteVariables} />
                            )}
                        </React.Suspense>
                    </ChartTheme>
                );
            }}
        />
    );
}
